import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Form, Alert, Spinner } from 'react-bootstrap';
import { Auth } from "../services/api";
import './ResetPassword.css';

const ResetPassword = () => {
  const [params] = useSearchParams();
  const uid = params.get('uid');
  const token = params.get('token');
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setLoading(true);

    try {
      await Auth.reset({ uid, token, new_password: newPassword });  
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      const msg =
        err.response?.data?.non_field_errors?.[0] ||
        err.response?.data?.token ||
        err.response?.data?.detail ||
        'Reset failed. The link may be invalid or expired. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-card">
        <h2 className="reset-title">Reset Your Password</h2>

        {/* ✅ Feedback messages */}
        {loading && (
          <Alert variant="info" className="text-center">
            <Spinner animation="border" size="sm" className="me-2" />
            We’re resetting your password, please wait...
          </Alert>
        )}
        {error && !loading && (
          <Alert variant="danger" className="reset-alert">
            {error}
          </Alert>
        )}
        {success && !loading && (
          <Alert variant="success" className="reset-alert">
            Password reset successful! Redirecting to login...
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formNewPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </Form.Group>

          <button
            type="submit"
            className="reset-button mt-3"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Resetting...
              </>
            ) : (
              'Reset Password'
            )}
          </button>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
